import { CSSProperties } from "react";
import { ControlSize } from "../types";

export const controlGroupControlStyles =
  "h-full min-w-0 flex-1 rounded-none border-0 ring-0 focus:border-transparent focus:ring-0 focus-within:ring-0";

export const controlGroupContentSizeStyles =
  "px-[var(--control-group-padding-inline,0.75rem)] py-[var(--control-group-padding-block,0.375rem)] text-[length:var(--control-group-font-size,1rem)] leading-[var(--control-group-line-height,1.5rem)]";

export type ControlGroupStyle = CSSProperties & Record<`--${string}`, string>;

export const controlGroupSizeStyles: Record<ControlSize, ControlGroupStyle> = {
  sm: {
    "--control-group-height": "30px",
    "--control-group-icon-size": "17px",
    "--control-group-line-height": "1.25rem",
    "--control-group-padding-block": "0.25rem",
    "--control-group-padding-inline": "0.5rem",
    "--control-group-font-size": "0.875rem",
  },
  md: {
    "--control-group-height": "38px",
    "--control-group-icon-size": "21px",
    "--control-group-line-height": "1.5rem",
    "--control-group-padding-block": "0.375rem",
    "--control-group-padding-inline": "0.75rem",
    "--control-group-font-size": "1rem",
  },
  lg: {
    "--control-group-height": "46px",
    "--control-group-icon-size": "24px",
    "--control-group-line-height": "1.75rem",
    "--control-group-padding-block": "0.5rem",
    "--control-group-padding-inline": "1rem",
    "--control-group-font-size": "1.25rem",
  },
};
